import { Badge } from '@/components/ui/badge';
import { formatNumber } from '@/lib/currency.utils';

interface BudgetDeviationBadgeProps {
  deviation: number;
}

export function BudgetDeviationBadge({ deviation }: BudgetDeviationBadgeProps) {
  const isOverBudget = deviation > 0;
  const variant = isOverBudget ? 'destructive' : 'secondary';
  const sign = deviation > 0 ? '+' : '';
  const formatted = `${sign}${formatNumber(deviation, 2)}`;

  return (
    <Badge variant={variant} className={isOverBudget ? '' : 'bg-green-600 hover:bg-green-700'}>
      {formatted}
    </Badge>
  );
}
